import { WorkspacePlanTier } from "../../interfaces";

export const MAX_QUANTITIES: Record<WorkspacePlanTier, number> = {
    [WorkspacePlanTier.BASIC]: 1,
    [WorkspacePlanTier.PRO]: 1,
    [WorkspacePlanTier.TEAM]: 20,
    [WorkspacePlanTier.ENTERPRISE]: Number.MAX_SAFE_INTEGER
};
